const config = {
  debug: import.meta.env.MODE === "development",
  cookie: {
    domain: ".ordbogen.com",
    prefix: "abc"
  },
  site: {
    name: "abc",
    label: "abc.ordbogen.com",
    title: "ABC-Ordbogen"
  },
  matomo: {
    host: import.meta.env.VITE_MATOMO_HOST,
    siteId: import.meta.env.VITE_MATOMO_SITE_ID
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    enabled: import.meta.env.MODE === "production",
    environment: import.meta.env.MODE
  },
  api: {
    baseUrl: "/api",
    versions: {
      v2: "v2"
    },
    vocab: {
      namespace: "vocab",
      versions: {
        v2: "v2"
      }
    },
    inflectionTrainer: {
      namespace: "inflection-trainer",
      versions: {
        v1: "v1"
      }
    }
  },
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1280
  }
};

export default config;
export const BREAKPOINTS = config.breakpoints;
